import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalMeetingsService } from "services/ClientPortalMeetingsService";
import { ClientPortalMeetingModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  Meeting: new ClientPortalMeetingModel(),
  Loading: false,
};

export const MeetingDetailsSlice = createSlice({
  name: "MeetingDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMeeting.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getMeeting.fulfilled, (state, action) => {
        state.Meeting = action.payload;
        state.Loading = false;
      })
      .addCase(getMeeting.rejected, (state) => {
        state.Meeting = new ClientPortalMeetingModel();
        state.Loading = false;
      });
  },
});

export const getMeeting = createAsyncThunk<ClientPortalMeetingModel, number>(
  "MeetingDetails/GetMeeting",
  async (meetingID) => {
    const meetingsService = container.get<IClientPortalMeetingsService>(SERVICE_TYPES.CPLClientPortalMeetingsService);
    return await meetingsService.getMeeting(meetingID);
  }
);

export const selectMeeting = (state: RootState) => state.meetingDetails.Meeting;
export const selectLoadingMeeting = (state: RootState) => state.meetingDetails.Loading;

export default MeetingDetailsSlice.reducer;
